const formatter = Intl.NumberFormat('en-US', {notation: "compact"});

export function formatNumber(number){
    return formatter.format(number)
} 
